<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원그룹설정</span>
            <span class="txt">
                회원그룹을 설정하고 회원을 포함시킬 수 있습니다. 회원을 구분하여 관리 및 조회 할 경우 도움이 됩니다.
            </span>
        </div>

        <div class="member-group-content">
            <span class="title">그룹명</span>
            <div class="check-area">
                <div class="check-btn">
                    <div class="com-radio-txt">
                        <input id="check-1-1" checked name="check-1" type="radio" @click="onClickTeamName(0)" />
                        <label for="check-1-1">소속없음</label>
                    </div>
                    <div
                        v-for="(mg, index) in memberGroupList"
                        :key="index + 2"
                        class="com-radio-txt"
                        @click="onClickTeamName(mg.c_center_cust_team_id)"
                    >
                        <input :id="`check-1-${index + 2}`" name="check-1" type="radio" />
                        <label :for="`check-1-${index + 2}`">{{ mg.c_center_cust_team_nm }}</label>
                    </div>
                    <!--                    <div class="com-radio-txt">-->
                    <!--                        <input type="radio" name="check-1" id="check-1-3">-->
                    <!--                        <label for="check-1-3">FC팀</label>-->
                    <!--                    </div>-->
                    <button class="com-setting-btn" @click="groupPop = true"><span class="blind">설정</span></button>
                </div>
            </div>
        </div>
        <div class="com-table-top">
            <span class="title">소속된 회원</span>
            <loading-spinner v-if="isLoading"></loading-spinner>
            <table v-else class="com-table">
                <colgroup>
                    <col style="width: 100px" />
                    <col style="width: 110px" />
                    <col style="width: 170px" />
                    <col style="width: 170px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                    <col style="width: 140px" />
                    <col style="width: 270px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>번호</th>
                        <th>
                            <button @click="onClickCustNameColumn">회원명</button>
                        </th>
                        <th>연락처</th>
                        <th>생년월일</th>
                        <th>유효여부</th>
                        <th>상담건수</th>
                        <th>
                            <button @click="onClickTicketCountColumn">이용권등록수</button>
                        </th>
                        <th>
                            <button @click="onClickMileageColumn">마일리지</button>
                        </th>
                        <th>
                            <button @click="onClickCreDtColumn">등록일</button>
                        </th>
                        <th>센터명</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(m, index) in teamMemberList">
                        <td>{{ index + 1 }}</td>
                        <td>{{ m.c_namee }}</td>
                        <td>{{ m.c_phone | phoneNumberFilter }}</td>
                        <td>{{ m.c_birthday | dateFormatFilter }}</td>
                        <td>{{ parseInt(m.c_prod_type_cd_cnt) > 0 ? '유효회원' : '-' }}</td>
                        <!-- 이용권 등록수가 1개 이상이면 유효회원, 그렇지 않으면 '-' 로 표시  -->
                        <td>{{ m.c_coneter_consult_cnt }}</td>
                        <td>{{ m.c_prod_type_cd_cnt }}</td>
                        <td>{{ m.c_mileage | numberFormatFilter }}</td>
                        <td>{{ m.c_cre_dt | timestampFilter }}</td>
                        <td>{{ m.c_center_nm }}</td>
                    </tr>
                    <tr v-if="teamMemberList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="onChangeLimit"
                ></select-form>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>

        <!-- 그룹명 설정 팝업 -->
        <div v-show="groupPop" class="layer-pop square-type">
            <div class="view-content">
                <button class="close" @click="groupPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="sub-title">그룹명 설정</span>
                    <p class="sub-txt">
                        그룹명의 이름을 추가, 수정 및 삭제 할 수 있습니다.
                        <br />
                        그룹명 삭제 시, 해당 그룹 소속이었던 회원은 소속없음 카테고리로 자동분류 됩니다.
                    </p>
                    <loading-spinner v-if="popupIsLoading"></loading-spinner>
                    <div v-else class="del-box">
                        <div class="input-cnt flex-col">
                            <div v-for="(mg, index) in memberGroupList" v-if="mg.c_del_yn === false" class="line">
                                <input
                                    :key="index"
                                    ref="memberGroupArray"
                                    v-model="mg.c_center_cust_team_nm"
                                    type="text"
                                />
                                <button
                                    class="com-btn"
                                    @click="onClickDeleteMemberGroup(mg.c_center_id, mg.c_center_cust_team_id, index)"
                                >
                                    삭제
                                </button>
                            </div>
                            <div v-for="(t, index) in addMemberGroupList" v-if="addMemberGroupList" class="line">
                                <input v-model="t.centerCustomerTeamName" type="text" />
                                <button class="com-btn" @click="onClickDeleteAddedMemberGroup(index)">삭제</button>
                            </div>
                        </div>
                        <div class="add-btn-cnt">
                            <div class="line">
                                <button class="com-btn" @click="onClickAddMemberGroup">+추가</button>
                            </div>
                        </div>
                    </div>

                    <div class="bottom-btn">
                        <button class="com-btn" @click="groupPop = false">취소</button>
                        <button class="com-btn blue" @click="onClickSaveMemberGroup">저장</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'SettingMemberGroup',
    components: { LoadingSpinner },
    props: {},
    computed: {},
    mounted() {
        this.centerId = this.$store.state.auth.user.centerId; // 로그인 센터 Id
        this.init();
    },
    data() {
        return {
            isLoading: false,
            popupIsLoading: false,
            centerId: '',
            groupPop: false,
            memberGroupList: null,
            addMemberGroupList: [], // 그룹명 설정에서 새로 추가하는 그룹
            curSelectedTeamId: '', // 현재 선택되어 있는 teamId

            teamMemberList: [], // 소속된 회원
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],
            pagingInfo: { ...pagingInfo },

            sortType: 'DESC', // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
            sortColumn: '', // 정렬컬럼 (회원명 : name, 이용권등록수 : ticketCount, 마일리지 : mileage, 등록일 : createAt)
        };
    },
    methods: {
        // 초기화
        async init() {
            await this.fetchMemberGroupList();
            await this.onClickTeamName(0); // 처음에는 소속없는 회원을 불러옴
        },

        // 한 페이지에 표시되는 줄 수 변경
        onChangeLimit(val) {
            this.pagingInfo.limit = val;
            this.onClickTeamName(this.curSelectedTeamId); // 현재 선택되어 있는 그룹으로 다시 조회
        },

        // 센터회원팀 목록 조회
        async fetchMemberGroupList() {
            try {
                this.isLoading = true;
                this.memberGroupList = [];
                const { data } = await this.sendGetMemberGroupList();
                this.memberGroupList = data;
                console.log('===> Success Load Center Group List : ', data);
                this.isLoading = false;
            } catch (error) {
                console.log('회원그룹을 가져오지 못했습니다.');
                console.log(error);
            }
        },

        // 센터회원팀 API 호출
        sendGetMemberGroupList() {
            return api.get(`/admin/api/center/${this.centerId}/customer-team`);
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onClickTeamName(this.curSelectedTeamId);
        },

        // 페이징 Param set
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 회원그룹 삭제 버튼 클릭시
        async onClickDeleteMemberGroup(centerId, customerTeamId) {
            try {
                if (!confirm('그룹을 삭제하시겠습니까?')) {
                    return false;
                }
                this.popupIsLoading = true;
                const { data } = await this.sendDeleteMemberGroup(centerId, customerTeamId);
                console.log(
                    '===> Success Delete Center Group : ',
                    'centerId : ',
                    centerId,
                    'customerTeamId : ',
                    customerTeamId
                );
                this.memberGroupList = null; // 회원그룹 배열 초기화
                alert('회원그룹이 삭제 되었습니다.');
                await this.fetchMemberGroupList(); // 회원그룹 다시 가져오기
                this.onClickTeamName(0);
                this.popupIsLoading = false;
            } catch (error) {
                alert('회원그룹 삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 추가된 회원그룹 삭제 버튼 클릭시
        onClickDeleteAddedMemberGroup(index) {
            this.addMemberGroupList.splice(index, 1);
        },

        // 센터팀 삭제 API 호출
        sendDeleteMemberGroup(centerId, customerTeamId) {
            return api.delete(`/admin/api/center/${centerId}/customer-team/${customerTeamId}`);
        },

        // 회원그룹 추가 버튼 클릭시
        onClickAddMemberGroup() {
            this.addMemberGroupList.push({
                centerCustomerTeamName: '',
            });
        },

        // 그룹명 설정에서 저장 버튼 클릭시
        async onClickSaveMemberGroup() {
            try {
                this.popupIsLoading = true;
                const { data } = await this.sendPutMemberGroup();
                console.log(data);
                alert('그룹명이 저장 되었습니다.');
                await this.fetchMemberGroupList();
                this.popupIsLoading = false;
                this.addMemberGroupList = [];
            } catch (error) {
                console.log(error);
                alert('그룹명 저장 중 오류가 발생했습니다.');
            }
        },

        // 회원그룹명 추가/수정 저장 API 호출
        sendPutMemberGroup() {
            const params = this.getPutMemberGroupParams();
            return api.put(`/admin/api/center/${this.centerId}/customer-team`, {
                ...params,
            });
        },

        // 그룹명 설정 저장 파라미터 가공
        getPutMemberGroupParams() {
            const params = {
                teamInfos: [],
            };

            // 기존 추가 되어 있던 그룹 가공
            this.memberGroupList.forEach((group) => {
                const temp = {
                    centerCustomerTeamId: group.c_center_cust_team_id,
                    centerCustomerTeamName: group.c_center_cust_team_nm,
                };
                params.teamInfos.push(temp);
            });

            // 새로 추가한 그룹 가공
            this.addMemberGroupList.forEach((group) => {
                const temp = {
                    centerCustomerTeamName: group.centerCustomerTeamName,
                };
                params.teamInfos.push(temp);
            });
            console.log('params :', params);
            return params;
        },

        // 회원 그룹명 버튼 클릭시
        async onClickTeamName(teamId) {
            try {
                this.isLoading = true;
                const { data } = await this.sendGetTeamMember(teamId);
                this.setPageParams(data);
                this.teamMemberList = data.items;
                console.log('===> Success Load Team Member List : ', data.items);
                this.curSelectedTeamId = teamId;
                this.isLoading = false;
            } catch (error) {
                alert('회원을 불러오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 회원 그룹에 속한 멤버 조회 API
        sendGetTeamMember(teamId) {
            const params = {
                sortType: this.sortType, // 정렬방법 (오름차순 : ASC, 내림차순 : DESC)
                sortColumn: this.sortColumn, // 정렬컬럼
            };
            return api.get(`/admin/api/center/${this.centerId}/customer-team/${teamId}/team-member`, {
                params: {
                    ...this.pagingInfo,
                    ...params,
                },
            });
        },

        // 회원명 컬럼 클릭시
        onClickCustNameColumn() {
            this.sortColumn = 'name';
            if (this.sortType === '' || this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }
            this.onClickTeamName(this.curSelectedTeamId);
        },

        // 이용권 등록수 컬럼 클릭시
        onClickTicketCountColumn() {
            this.sortColumn = 'ticketCount';
            if (this.sortType === '' || this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }
            this.onClickTeamName(this.curSelectedTeamId);
        },

        // 마일리지 컬럼 클릭시
        onClickMileageColumn() {
            this.sortColumn = 'mileage';
            if (this.sortType === '' || this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }
            this.onClickTeamName(this.curSelectedTeamId);
        },

        // 등록일 컬럼 클릭시
        onClickCreDtColumn() {
            this.sortColumn = 'createAt';
            if (this.sortType === '' || this.sortType === 'DESC') {
                this.sortType = 'ASC';
            } else {
                this.sortType = 'DESC';
            }
            this.onClickTeamName(this.curSelectedTeamId);
        },
    },
};
</script>
<style lang="scss"></style>
